import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from 'src/app/shared/services/authservices/login.service';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import Swal from 'sweetalert2';
declare let $: any;
// import { PaySlipComponent } from '../pay-slip/pay-slip.component';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent]
})
export class MainComponentPayroll implements OnInit {
  public salaries: any = [];
  public showSpinner = false;
  public user: any = [];
  isPayRoll = true;
  isLoans = false;
  userLoan: any;
  imagepath: any;
  selectedDuration: number | undefined;
  private _location: any;
  loanDate: any;
  fileName: any;
  imagePath: any;
  formData: FormData = new FormData();
  fileToUpload: any;
  loanPurpose: any;
  reason: any;
  selectedLoanid: any;
  userLoanReq: any;
  amount: any;
  dateloan: any;
  loandate: any;
  loanFile: any;
  selectimg: any;
  showThirdButton = false;
  ishidden: any;
  loanreq: any;
  loanDetail: any;
  totalAmount: any;
  total_duration: any;
  paid_installment: any;
  remaining_amount: any;
  remaining_months: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  refresh: any;
  activeloan = false;
  constructor(
    private mediaService: MediaService,
    private _loginService: LoginService,
    public payrollService: PayrollService,
    // public paySlip: PaySlipComponent,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private activatedRoute: ActivatedRoute
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const fromLoanRequestPage = params['fromLoanRequest'];
      if (fromLoanRequestPage === "true") {

        this.isLoans= true
        $("#tabel-header,.attendance-filter-section").removeClass("tabel-header");
        $('#payrollModal').modal('hide');
      } else {
        // Hide the modal
        $('#payrollModal').modal('show');
        $('#payrollModal').modal({ backdrop: 'static', keyboard: false })
        this.isLoans= false

      }

    });




    this.loanRequest();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.hideModal();

  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {

      this.refresh = value.data.user
      this.user = this.refresh;
    })

  }

  addrequestBtn() {
    this.router.navigate(['/loan-request']);
  }
  gotoDashboard() {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    this.hideModal();
    if (user_role.role_type == "Employee") {
      this.router.navigate(['/dashboard-1']);
    } else {
      this.router.navigate(['/new-admin-dashboard']);
    }
  }
  hideModal() {
    $('#payrollModal').modal('hide');
  }
  getAllPayroll(month?: string, year?: number) {
    this.payrollService.getPayroll(month, year).then((value) => {
      if (value.success == true) {
        this.salaries = value.data
      }
      this.showSpinner = false;
    });
  }

  public sumFunction(a: any, b: any, c: any) {

    return a + b + c;
  }

  public getCurrentMonth() {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const d = new Date();
    // document.write('The current month is ' + monthNames[d.getMonth()]);
    return monthNames[d.getMonth()];
  }

  onReset() {
    this.showSpinner = true;
    //alert("reset here");
    this.getAllPayroll();
  }
  onSubmitPincode(f: NgForm) {

    const pincode = f.value.pin;
    if (pincode.length == 0) {
      this.showError("Enter your Pincode!")
      return;
    }
    this.showSpinner = true;
    this._loginService
      .checkPincode(this.user.email,
        pincode)
      .then((value) => {
        if (value.success == true) {
          // Show SweetAlert success modal
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Your pincode verified Successfully!',
            showConfirmButton: false,
            timer: 1500,  // SweetAlert will close automatically after 1500ms
          }).then(() => {
            // After SweetAlert closes, hide the payroll modal
            $('#payrollModal').modal('hide');
            // Optionally remove any other classes or perform other actions here
            $("#tabel-header,.attendance-filter-section").removeClass("tabel-header");
            this.getAllPayroll(); // Call your method here
          });

        } else {
          // If the verification fails, show the error message
          this.showSpinner = false;
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,  // SweetAlert will close automatically after 3000ms
          });
        }
      });


  }
  showError(message: string) {
    Swal.fire({
      iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  }
  onSubmit(f: NgForm) {
    this.showSpinner = true;
    // alert('submitted');

    this.salaries = [];

    this.payrollService
      .getPayrollFilter(
        f.value.startdate,
        f.value.enddate,
        f.value.month,
        f.value.year
      )
      .then((value) => {
        // alert('after filter');
        this.showSpinner = false;
      });
  }

  showSlip(data: any) {
    this.router.navigate(['/pay_slip'], {
      queryParams: { data: JSON.stringify(data) },
      skipLocationChange: true,
    });
  }


  payRollEmployee() {
    this.isPayRoll = true;
    this.isLoans = false;
  }
  // tabs funtion
  employeeLoansRequest() {
    this.isPayRoll = false;
    this.isLoans = true;

  }
  // hiddenbutton(selectedLoanid:any){

  // // this.selectedLoanid
  // this.payrollService.getuserReq(selectedLoanid).then((value) => {

  //   if (value.success == true) {


  //     this.loanreq = value.data;
  //   }
  //   this.showSpinner = false;
  //   this.newFunction();
  // })
  // }
  newFunction() {


    this.isPayRoll = false;
    this.isLoans = false;
    this.ishidden = true;
  }

  loanRequest() {
    this.showSpinner = true;
    this.payrollService.getLoanReq().then((value) => {

      if (value.success == true) {
        this.userLoan = value.data
      }
      this.showSpinner = false;
    });

  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'completed':
        return '#4FDDAD';
      case 'approved':
        return '#4FDDAD';
      case 'rejected':
        return '#FF5050';
      case 'pending':
        return '#1D3E75';
      default:
        return 'white';
    }
  }


  selectLoanid(id: any) {

    this.showSpinner = true;
    this.selectedLoanid = id;
    // this.hiddenbutton(this.selectedLoanid);
    this.payrollService.getuserReq(id).then((value) => {
      if (value.success == true) {
        this.userLoanReq = value.data;
        this.selectimg = value.data.loan_file
        this.amount = this.userLoanReq.loan_amount;
        this.dateloan = this.userLoanReq.loan_duration;
        this.loandate = this.userLoanReq.loan_date;
        this.loanAmountValue = this.amount;
        this.calculatedInstallmentAmount = this.userLoanReq.installment;
        this.reason = this.userLoanReq.loan_reason
        this.imagePath = this.userLoanReq.loan_file
        this.paid_installment = this.userLoanReq.paid_intallement_count
        // this.newFunction();

      }
      this.showSpinner = false;
    });


  }

  // LOANDETAIL
  loandetail(id: any) {
    this.showSpinner = true;


    this.payrollService.LoanReq(id).then((value) => {

      this.loanDetail = value.data
      this.totalAmount = this.loanDetail.total_amount
      this.total_duration = this.loanDetail.total_duration
      this.paid_installment = this.loanDetail.paid_months
      this.remaining_amount = this.loanDetail.remaining_amount
      this.remaining_months = this.loanDetail.remaining_months



      this.showSpinner = false;
    })
  }







  selectimage(img: any) {

    this.selectimg = img
  }


  downloadImage() {
    // Create a new XMLHttpRequest or use the fetch API to fetch the image as a blob
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';

    xhr.onload = () => {
      const blob = xhr.response;

      // Create a blob URL and trigger the download
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'image.jpg'; // Change the filename as needed

      // Trigger the click event on the anchor to start the download
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(blobUrl);
    };

    xhr.open('GET', this.selectimg, true);
    xhr.send();
  }


  loanAmountValue: number | null = null;
  calculatedInstallmentAmount: number | null = null;
  durations: number[] = [1, 2, 3, 4, 5, 6];

  selectDuration(duration: number): void {
    this.selectedDuration = duration;
    this.calculateInstallmentAmount();
  }

  calculateInstallmentAmount(): void {

    if (this.selectedDuration && this.loanAmountValue) {
      this.calculatedInstallmentAmount = parseFloat((this.loanAmountValue / this.selectedDuration).toFixed(2));
      ;
    } else {
      this.calculatedInstallmentAmount = null;
    }
  }

  selectedImage: string | ArrayBuffer | null = null; // This will store the selected image data
  profileImageInvalid = false;
  onFileChange(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileToUpload = event.target.files[0] as File;
      this.formData.append('file', fileToUpload, fileToUpload.name);
      this.uploadDocumentImage()
      const fileSizeKB = selectedFile.size / 1024;
      if (fileSizeKB <= 1025) {

        this.profileImageInvalid = false;

        // Read the selected image and convert it to a data URL
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImage = e.target.result; // Set the selected image data
        };
        reader.readAsDataURL(selectedFile);
      } else {

        this.selectedImage = null;
        this.profileImageInvalid = true;
        event.target.value = ''; // Clear the input value
      }
    }
  }


  trimText() {
    this.reason = this.reason.replace(/\s+/g, ' ').trim();
  }
  uploadDocumentImage() {
    this.showSpinner = true;
    this.mediaService
      .uploadImage(this.formData)
      .subscribe(response => {
        this.showSpinner = false;
        let l: any;
        l = response;
        this.imagePath = l.data.path;
      },
        error => {
          this.showSpinner = false;
        }
      );
  }

  // Delete loan req
  deleteLoan(id: any) {
    this.payrollService.delLoanreq(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload();
        this.router.navigate(['/payroll'], { queryParams: { fromLoanRequest: true } });

      } else {
        this.showSpinner = false;
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
        this.router.navigate(['/payroll'], { queryParams: { fromLoanRequest: true } });
      }
      this.showSpinner = false;
    });
  }

  updateLoanReq(f: NgForm) {

    this.payrollService.uploadLoan(
      this.selectedLoanid,
      f.value.loanAmountValue,
      f.value.loanDate,
      this.selectedDuration,
      this.calculatedInstallmentAmount,
      f.value.loanPurpose,
      this.fileToUpload,
      this.imagePath





    )
      .then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'User Account No Updated Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          window.location.reload();
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });

  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

}
